export default "__VITE_ASSET__BrQArRdW__"